import { render } from "./my-profile.vue?vue&type=template&id=7a46a1f5&scoped=true"
import script from "./my-profile.vue?vue&type=script&lang=js"
export * from "./my-profile.vue?vue&type=script&lang=js"

import "./my-profile.vue?vue&type=style&index=0&id=7a46a1f5&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a46a1f5"]])

export default __exports__